module.exports = __webpack_public_path__ + "img/nigeria.e29cb79b.png";